import React, { useEffect, useRef, useState } from 'react';

const requestIdle = (callback, timeout) => {
    if (window.requestIdleCallback) {
        const id = window.requestIdleCallback(callback, { timeout });
        return () => window.cancelIdleCallback(id);
    }

    const id = window.setTimeout(callback, timeout);
    return () => window.clearTimeout(id);
};

const DeferredRender = ({
    children,
    fallback = null,
    rootMargin = '600px',
    idleTimeout = 1400,
}) => {
    const [render, setRender] = useState(false);
    const markerRef = useRef(null);

    useEffect(() => {
        if (render) {
            return undefined;
        }

        let cancelled = false;
        let observer = null;
        let cancelIdle = null;
        let frameId = null;

        const reveal = () => {
            if (!cancelled) {
                setRender(true);
            }
        };

        if ('IntersectionObserver' in window && markerRef.current) {
            observer = new IntersectionObserver((entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                    reveal();
                }
            }, { rootMargin });
            observer.observe(markerRef.current);
        }

        frameId = window.requestAnimationFrame(() => {
            cancelIdle = requestIdle(reveal, idleTimeout);
        });

        return () => {
            cancelled = true;

            if (observer) {
                observer.disconnect();
            }

            if (frameId) {
                window.cancelAnimationFrame(frameId);
            }

            if (cancelIdle) {
                cancelIdle();
            }
        };
    }, [idleTimeout, render, rootMargin]);

    if (render) {
        return children;
    }

    return <div ref={markerRef}>{fallback}</div>;
};

export default DeferredRender;
